import styled from 'styled-components';

export const TableWrapper = styled.div`
  max-width: 100%;
  overflow-x: auto;
  padding: 20px;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  overflow: hidden;
`;

export const StyledTh = styled.th`
  background-color: ${(props) => props.backgroundColor || '#f2f2f2'};
  color: white;
  font-weight: bold;
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
`;

export const StyledTd = styled.td`
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
`;

export const StyledTr = styled.tr`
  &:nth-child(even) {
    background-color: #f2f2f2;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const TableTitle = styled.h2`
  margin-bottom: 10px;
  color: #333;
`;

export const MessageWrapper = styled.div`
  text-align: center;
  padding: 20px;
  font-size: 18px;
  color: #555;
`;

export const DetailsButton = styled.button`
  background: transparent;
  color: #27AAE1;
  border: none;
  padding: 8px 16px;
  cursor: pointer;
  font-size: 14px;
  transition: color 0.3s;
  text-decoration: underline;

  &:hover:not(:disabled) {
    color: #1e8fc7;
  }

  &:disabled {
    color: #ccc;
    cursor: not-allowed;
    opacity: 0.6;
    text-decoration: none;
  }
`;

export const DetailsContent = styled.div`
  padding: 10px;
  font-size: 14px;
  line-height: 1.5;
`;

export const ModalLoadingWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px;
`;

export const DetailsTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: #fff;
  margin-top: 10px;
`;

export const DetailsTh = styled.th`
  background-color: ${(props) => props.backgroundColor || '#27AAE1'};
  color: white;
  font-weight: bold;
  padding: 12px 15px;
  text-align: left;
  border-bottom: 2px solid #ddd;
`;

export const DetailsTd = styled.td`
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #ddd;
`;

export const DetailsTr = styled.tr`
  &:nth-child(even) {
    background-color: #f9f9f9;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;

export const ModalContentWrapper = styled.div`
  position: relative;
  padding: 20px;
  min-width: 500px;
`;

export const CloseButton = styled.button`
  position: absolute;
  top: -10px;
  right: 10px;
  background: transparent;
  border: none;
  font-size: 32px;
  line-height: 1;
  color: #666;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: color 0.3s, transform 0.2s;
  z-index: 10;

  &:hover {
    color: #000;
    transform: scale(1.1);
  }

  &:active {
    transform: scale(0.95);
  }
`;